export var Stylable;

(function (Stylable) {
  var Style;

  (function (Style) {
    Style["BOLD"] = "bold";
    Style["ITALIC"] = "italic";
    Style["UNDERLINED"] = "underlined";
    Style["SUBSCRIPT"] = "subscript";
    Style["SUPERSCRIPT"] = "superscript";
    Style["HIGHLIGHTED"] = "highlighted";
  })(Style = Stylable.Style || (Stylable.Style = {}));

  function validateStylable(value, styles) {
    var marks = styles !== null && styles !== void 0 ? styles : Object.values(Style);
    var isValid = marks.every(mark => !(mark in value) || typeof value[mark] === 'boolean');
    return isValid ? value : null;
  }

  Stylable.validateStylable = validateStylable;
})(Stylable || (Stylable = {}));